import { render, staticRenderFns } from "./TradingView.vue?vue&type=template&id=3bbd04ca&"
import script from "./TradingView.vue?vue&type=script&lang=ts&"
export * from "./TradingView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports